import "./Layout.css";

import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import HomeIcon from "@mui/icons-material/Home";
import Logout from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import { useUnleashContext } from "@unleash/proxy-client-react";
import { useSignOut } from "react-auth-kit";
import logo from "./abe_logo.png";
import { PAGES } from "./constants";

const Layout = () => {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const updateContext = useUnleashContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Set the minimum height of Layout-page-content to the height of the window minus the height of the header
  useEffect(() => {
    const headerHeight = document.getElementsByClassName("Layout-title-bar")[0].offsetHeight;
    const pageContent = document.getElementsByClassName("Layout-page-content")[0];
    pageContent.style.minHeight = `calc(100vh - ${headerHeight}px)`;
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHomeButton = () => {
    handleClose();
    navigate(PAGES.HOME);
  }

  const handleLogout = () => {
    updateContext({ userId: null });
    handleClose();
    signOut();
  }

  const handleSupportButton = () => {
    handleClose();
    navigate(PAGES.CONTACT_US);
  }

  const handleProfileButton = () => {
    handleClose();
    navigate(PAGES.PROFILE);
  }

  return (
    <>
      <div className="Layout-title-bar" data-testid="title-bar">
        <img src={logo} className="Layout-logo" alt="logo" data-testid="title-bar-logo" onClick={() => navigate(PAGES.HOME)} />
        {/* <button className="signout-button" onClick={() => signOut()}>Sign Out</button> */}
        <Tooltip title="User Options">
          <IconButton
            id="Layout-account-menu-button"
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'Layout-account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}></Avatar>
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          id="Layout-account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
          }}

          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleHomeButton}>
            <Avatar>
              <HomeIcon />
            </Avatar> Home
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleProfileButton}>
            <Avatar /> Profile
          </MenuItem>
          <MenuItem onClick={handleSupportButton}>
            <Avatar>
              <ContactSupportIcon />
            </Avatar> Support
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </div>

      <div className="Layout-page-content">
        <Outlet />
      </div>
    </>
  )
};

export default Layout;